import React from 'react'
import { SiDiscord } from "react-icons/si"
import { TbBrandDiscord } from "react-icons/tb"
import { AiOutlineInstagram } from "react-icons/ai"
import { FiTwitter } from "react-icons/fi"
import "./Footer.css"

const Footer = () => {
    return (
        <div className='flex flex-col flex-wrap  relative    w-full h-auto pt-16 justify-center items-center  '>
            <div className='container mx-auto flex flex-col flex-wrap justify-center items-center '>
                <div className='text-white w-full h-auto flex flex-col flex-wrap justify-center items-center z-10'>
                    <h2 className=' text-3xl font-turrent'>Join us on Discord !</h2>
                    <div className=' flex flex-col text-6xl mt-10 rounded-full p-5 cursor-pointer disco_container'>
                        <SiDiscord className=' disc' />
                    </div>
                </div>
                <div className=' text-black flex flex-col mt-10 z-10  '>
                    <div className=' flex flex-col w-full  h-auto justify-center items-center'>
                       <a href='/'> <img src={require("../../assets/images/Scribs-logo-2.png")} className=' w-[100px] h-fit' alt='logo'/></a>
                    </div>
                    <div className=' flex flex-row flex-wrap justify-center items-center mt-4 text-2xl'>
                        <div className=' mx-3 cursor-pointer'>
                            <AiOutlineInstagram className='media' />
                        </div>
                        <div className=' mx-3 cursor-pointer'>
                            <FiTwitter className='media' />
                        </div>
                        <div className=' mx-3 cursor-pointer'>

                            <TbBrandDiscord className='media' />

                        </div>
                    </div>
                    <div className=' mt-2'>
                        <p>2022 SCRIB | All rights reserved</p>
                    </div>
                </div>
            </div>
            <div className='wave '>

            </div>
        </div>
    )
}

export default Footer